import WebApp from '@twa-dev/sdk'

type HapticFeedback = typeof WebApp.HapticFeedback

/**
 * Telegram haptics. Outside Telegram (browser dev, older clients without
 * HapticFeedback) every call is a no-op.
 */
function haptic(run: (feedback: HapticFeedback) => void): void {
    try {
        run(WebApp.HapticFeedback)
    } catch {
        // Not running inside Telegram
    }
}

/** A tab or segment changed. */
export function hapticSelection(): void {
    haptic((f) => f.selectionChanged())
}

/** A primary action was pressed: start, save, pay. */
export function hapticTap(): void {
    haptic((f) => f.impactOccurred('light'))
}

/** An action finished: enrolled, saved, paid; or failed. */
export function hapticResult(kind: 'success' | 'error'): void {
    haptic((f) => f.notificationOccurred(kind))
}
